import posthog from 'posthog-js';

const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_KEY as string | undefined;
const POSTHOG_HOST = (import.meta.env.VITE_POSTHOG_HOST as string) || 'https://us.i.posthog.com';

let initialized = false;

export function initAnalytics() {
  if (initialized) return;
  initialized = true;

  if (POSTHOG_KEY) {
    posthog.init(POSTHOG_KEY, {
      api_host: POSTHOG_HOST,
      autocapture: true,
      capture_pageview: true,
      capture_pageleave: true,
      persistence: 'localStorage',
      session_recording: {
        maskAllInputs: true,
      },
    });
  }
}

export function track(event: string, properties?: Record<string, unknown>) {
  if (POSTHOG_KEY) {
    posthog.capture(event, properties);
  }

  if (import.meta.env.DEV) {
    console.debug('[analytics]', event, properties);
  }
}

export function identify(userId: string, traits?: Record<string, unknown>) {
  if (POSTHOG_KEY) {
    posthog.identify(userId, traits);
  }
}

export const events = {
  walletConnected: (props: { address: string; network: string }) =>
    track('wallet_connected', props),

  // Seller funnel: create_lot_started → lot_created
  createLotStarted: () =>
    track('create_lot_started'),

  lotCreated: (props: { lotId: number; tonAmount: string; buyNowTon?: string; isPublic: boolean; assetCount: number }) =>
    track('lot_created', props),

  lotViewed: (props: { lotId: number }) =>
    track('lot_viewed', props),

  // Buyer funnel: offer_form_opened → offer_made
  offerFormOpened: (props: { lotId: number }) =>
    track('offer_form_opened', props),

  offerMade: (props: { lotId: number; tonAmount: string; assetCount: number }) =>
    track('offer_made', props),

  offerAccepted: (props: { lotId: number; offerId: number }) =>
    track('offer_accepted', props),

  offerRejected: (props: { lotId: number; offerId: number }) =>
    track('offer_rejected', props),

  instantBuyTriggered: (props: { lotId: number; amount: string }) =>
    track('instant_buy_triggered', props),

  shareClicked: (props: { lotId: number; platform: string }) =>
    track('share_clicked', props),

  searchPerformed: (props: { query: string; resultCount: number }) =>
    track('search_performed', props),

  pageViewed: (props: { page: string }) =>
    track('page_viewed', props),

  featureSuggested: (props: { title: string }) =>
    track('feature_suggested', props),

  featureVoted: (props: { featureKey: string }) =>
    track('feature_voted', props),

  channelAttribution: (props: {
    address: string; utmSource?: string; utmMedium?: string;
    utmCampaign?: string; referrer?: string; hasReferralCode: boolean;
  }) => track('channel_attribution', props),

  referralLinkShared: (props: { referrerAddress: string; shareMethod: string }) =>
    track('referral_link_shared', props),
} as const;
